import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Admin from './pages/Admin';
import AdminEmpresa from './pages/AdminEmpresa';
import ResetPassword from './pages/ResetPassword';
import Perfil from './pages/Perfil';
import RutaProtegida from './components/RutaProtegida';
import TestMonitor from './pages/testprueba';
import TerminosCondiciones from './pages/TerminosCondiciones';
import PoliticaPrivacidad from './pages/PoliticaPrivacidad';
import Reportes from './pages/Reportes';
import './index.css';

function FondoGlobal() {
  return (
    <div style={{
      backgroundColor: 'red',
    }} />
  );
}

function App() {
  return (
    <>
      <FondoGlobal />
      <BrowserRouter>
        <Routes>
          <Route path="/test" element={<TestMonitor />} />
          <Route path="/login" element={<Login />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/dashboard" element={<RutaProtegida><Dashboard /></RutaProtegida>} />
          <Route path="/admin" element={<RutaProtegida soloAdmin={true}><Admin /></RutaProtegida>} />
          <Route path="/mi-empresa" element={<RutaProtegida><AdminEmpresa /></RutaProtegida>} />
          <Route path="/perfil" element={<RutaProtegida><Perfil /></RutaProtegida>} />
          <Route path="/terminos-condiciones" element={<TerminosCondiciones />} />
          <Route path="/politica-privacidad" element={<PoliticaPrivacidad />} />
          <Route path="/reportes" element={<RutaProtegida><Reportes /></RutaProtegida>} />
          <Route path="*" element={<Navigate to="/dashboard" />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;